let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7CyTh")).then(() => parcelRequire('8COMr'));